import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { PessoaDTO } from '../../../models/clientes/pessoa.model';
import { PeriodoFiltro } from '../../../models/dashboard/periodo-filtro.model';
import { RelatorioContasAReceberParams } from '../../../models/relatorios/relatorio-contas-a-receber.model';
import { PessoaService } from '../../../services/pessoas/pessoas.service';
import { RelatorioContasAReceberService } from '../../../services/relatorios/relatorio-contas-a-receber.service';
import { calcularPeriodoPadraoRelatorio } from '../../../shared/utils/periodo-relatorio-padrao.util';
import { PRESETS_PERIODO_RELATORIO } from '../../../shared/utils/periodo.utils';
import { FileUtils } from '../../../shared/utils/file-utils';

@Component({
  selector: 'app-relatorio-contas-a-receber',
  templateUrl: './relatorio-contas-a-receber.component.html',
  styleUrls: ['./relatorio-contas-a-receber.component.scss']
})
export class RelatorioContasAReceberComponent implements OnInit {

  // Texto exibido no botao do filtro de periodo (app-periodo-filtro, modo avancado).
  periodoTexto = '';

  // Presets do filtro de periodo: lista padrao + "Mostrar todos" (so relatorios).
  readonly opcoesPeriodo = PRESETS_PERIODO_RELATORIO;

  // Parâmetros do relatório
  params: RelatorioContasAReceberParams = {
    tipoOperacaoFinanceira: 'ENTRADA', // fixo
    pessoaId: undefined,
    dataHoraInicial: '',
    dataHoraFinal: ''
  };

  // Lista de Clientes
  clientes: any[] = [];
  searchNome: string = '';
  loadingClientes: boolean = false;
  totalRecords: number = 0;
  first3: number = 0;
  selectedCliente: PessoaDTO | null = null;

  emitindoRelatorio: boolean = false;

  constructor(
    private relatorioService: RelatorioContasAReceberService,
    private translate: TranslateService,
    private messageService: MessageService,
    private pessoaService: PessoaService,
  ) { }

  ngOnInit(): void {
    this.inicializarPeriodoPadrao();
    this.findClientes();
  }

  // Inicializa o periodo padrao (Este mes) para que os params tenham datas
  // antes de o usuario abrir o dialog do filtro. O app-periodo-filtro nao
  // emite no init, entao replicamos o que o dashboard faz.
  private inicializarPeriodoPadrao(): void {
    this.aplicarPeriodo(calcularPeriodoPadraoRelatorio(this.translate));
  }

  // Handler do (periodoChanged) do app-periodo-filtro.
  onPeriodoChanged(periodo: PeriodoFiltro): void {
    this.aplicarPeriodo(periodo);
  }

  private aplicarPeriodo(periodo: PeriodoFiltro): void {
    this.params.dataHoraInicial = periodo.dataInicio;
    this.params.dataHoraFinal = periodo.dataFim;
    this.periodoTexto = periodo.texto;
  }

  findClientes(
    page: number = 0,
    size: number = 10,
    sort: string = 'id,asc',
  ) {
    let filter = `categoriaCliente=true`;

    if (this.searchNome && this.searchNome.trim() !== '') {
      const search = encodeURIComponent(this.searchNome.trim());

      filter += `&email=${search}`;
      filter += `&nome=${search}`;
      filter += `&fantasia=${search}`;
      filter += `&ruc=${search}`;
      filter += `&telefone=${search}`;
      filter += `&ci=${search}`;
      filter += `&nomeCidade=${search}`;

      if (!isNaN(Number(search))) {
        filter += `&codigoPessoa=${search}`;
      }
    }

    this.pessoaService
      .get('/pessoas/buscar', {
        page,
        size,
        sort,
        filter: filter,
      }).subscribe(
        (response) => {
          this.clientes = response.content;
          this.totalRecords = response.totalElements;
          this.first3 = page * size;
        },
        (error) => {
          console.error('Erro ao buscar clientes:', error);
          this.clientes = [];
          this.totalRecords = 0;
        }
      );
  }

  onClientesFilter(event: any) {
    this.searchNome = event.filter?.trim() || '';
    this.loadingClientes = true;
    this.findClientes();
    this.loadingClientes = false;
  }

  emitirRelatorio(): void {
    this.emitindoRelatorio = true;

    // As datas ja foram aplicadas em params via onPeriodoChanged / periodo padrao.
    this.params.pessoaId = this.selectedCliente ? this.selectedCliente.id : undefined;

    this.relatorioService.emitirRelatorio(this.params).subscribe({
      next: (base64Pdf: string) => {
        FileUtils.abrirPdf(base64Pdf, 'relatorio-contas-a-receber.pdf');
        this.emitindoRelatorio = false;
      },
      error: (err) => {
        console.error('Erro ao gerar relatório', err);
        this.emitindoRelatorio = false;

        if (err?.status === 404) {
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('common.aviso'),
            detail: this.translate.instant('relatorios.mensagens.nenhum_dado_encontrado'),
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('common.erro'),
            detail: this.translate.instant('relatorios.mensagens.erro_gerar_relatorio'),
          });
        }
      },
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.ctrlKey && event.key === 'Enter' && !this.emitindoRelatorio) {
      event.preventDefault();
      this.emitirRelatorio();
    }
  }

}
